const translations = {
    'tile.biome': 'biome: %s',
    'tile.controlled': 'Controlled region.',
    'tile.controlledHint': 'You can build here from settlements that control this area.',
    'tile.id': 'id: %s',
    'tile.foundFreePopulation': 'Free population available: %d',
    'tile.foundRequirement': 'Requires %d free population to found a settlement.',
    'tile.foundingInProgress': 'Founding expedition en route.',
    'tile.hostiles': 'Hostile presence',
    'tile.hostileFaction': 'Faction: %s',
    'tile.hostileCount': 'Troops: %d',
    'tile.enemyUnitLine': '%s: %d',
    'tile.enemiesTitle': 'Enemies',
    'tile.enemiesNone': 'No hostile forces detected.',
    'tile.enemiesDevNote': 'Dev-only visibility.',
    'tile.uncontrolled': 'Outside your control.',
    'tile.uncontrolledHint': 'Found a settlement to extend your control.',
    'tile.unoccupied': 'Unoccupied Region',
    'tile.occupied': 'Settlement',
    'tile.settlementName': 'name: %s',
    'tile.settlementPopulation': 'population: %d',
    'tile.settlementTier': 'tier: %s',
    'tile.position': 'position: { q:%d, r:%d, s:%d }',
    'tile.rawJson': 'Raw JSON',
    'tile.resources': 'resources: %s',
    'tile.scout': 'Scouting',
    'tile.scoutAction': 'Send scouts',
    'tile.scouts': 'Scouts',
    'tile.scoutsWaiting': 'Scouts await orders.',
    'tile.scoutsReturn': 'Return to settlement',
    'tile.scoutPlan': 'Scout orders',
    'tile.scoutPlanHint': 'Select this tile as the next target for the active scouts.',
    'tile.scoutPlanAction': 'Set next target',
    'tile.summary': 'Summary',
    'tile.tabSummary': 'Summary',
    'tile.tabEnemies': 'Enemies',
    'tile.tabSettlement': 'Settlement',
    'tile.tabRaw': 'Raw',
    'tile.title': 'Tile Details',
    'tile.undiscovered': 'Unknown Region',
    'tile.undiscoveredHint': 'Send scouts to reveal this area.',
};

export default translations;
